import { Injectable } from '@angular/core';
import { Project } from '../Project';
import { MatDialogRef } from '@angular/material/dialog';
import { Settings } from '@common/core/config/settings.service';

@Injectable({
  providedIn: 'root'
})
export class DnsPopupService {

  constructor(
    private settings: Settings
  ) { }
  project: Project;
  private dialogRef:MatDialogRef<any>;

  init(project: Project, dialogRef: MatDialogRef<any>) {
    this.project = project;
    this.dialogRef = dialogRef;
  }
  getUrl(file: string) {
    return `${this.project.s3_destination_url}/${file}`;
  }
}
